import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/region/api_region';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
// import * as selectors from '../../reducers/selectors';
import { browserHistory } from 'react-router';

export function* fetchListRegionSaga(feathersApp) {
  yield takeLatest('FETCH_REGION_LIST', callFetchListRegion, feathersApp);
}
function* callFetchListRegion(feathersApp, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = { 
      filters, 
      list_type: 'region'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}



export function* fetchRegionForEditSaga(feathersApp) {
  yield takeEvery('FETCH_REGION_FOR_EDIT', callFetchRegionForEdit, feathersApp);
}

function* callFetchRegionForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchRegionById, feathersApp, fetchParams);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}




export function* saveRegionSaga(feathersApp) {
  yield takeEvery("SAVE_REGION", callSaveRegion, feathersApp);
}
function* callSaveRegion(feathersApp, action) {
  const { tenant, user } = yield select();
  try {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { tenant, user, data: action.data };
    const result = yield call(api.saveRegion, feathersApp, params);
    const id = result && result.id;
    yield callFetchRegionForEdit(feathersApp, { id, silent: true });
    browserHistory.push(`/admin/region/edit/${id}`);
    yield common.doneSaveRecord(result, 'Region was saved');

  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteRegionSaga(feathersApp) {
  yield takeEvery('DELETE_REGION', callDeleteRegion, feathersApp);
}
function* callDeleteRegion(feathersApp, action) {
  const result = yield call(deleteRegion, feathersApp, action);
  yield delay(2000); 
  if (result) {
    browserHistory.push('/admin/region');
  }
}
function* deleteRegion(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const params = { tenant, user, id };
      result = yield call(api.deleteRegion, feathersApp, params);
      yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.REGION } });
    }
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}